import React from 'react';
import { ConfirmActionModal } from 'components/ui/modal';
import { useTranslation } from 'react-i18next';
export default function DeleteReportModal({ report, isOpen, onClose, onConfirm, }) {
    const { t } = useTranslation();
    if (!isOpen) {
        return null;
    }
    function handleConfirm() {
        onConfirm(report);
    }
    return ((React.createElement(ConfirmActionModal, { dataTestId: "ConfirmActionModal-3790d88e", title: t('DELETE_REPORT'), isOpen: isOpen, onClose: onClose, onConfirm: handleConfirm, confirmActionText: t('DELETE'), confirmActionColor: "red" }, (report === null || report === void 0 ? void 0 : report.name) ? (React.createElement("p", { "data-testid": "p-62038731", className: "my-0" },
        t('DELETE_REPORT_CONFIRMATION'),
        " ",
        React.createElement("strong", { "data-testid": "strong-3deff680" }, report === null || report === void 0 ? void 0 : report.name))) : (React.createElement("p", { "data-testid": "p-f546abbf", className: "my-0" }, t('DELETE_REPORT_CONFIRMATION_NONAME'))))));
}
